unit unit_Terminkalender;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, Vcl.StdCtrls,
  WEBLib.StdCtrls, Vcl.Controls, VCL.TMSFNCCustomControl,
  WEBLib.ExtCtrls, dateutils, WEBLib.Buttons, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.WebCtrls,
  DB;

type
  TTerminkalender = class(TForm)
    sourceTermine: TDataSource;
    XDTermine: TXDataWebDataSet;
    XDTermineUID: TStringField;
    XDTermineBeginn: TDateTimeField;
    XDTermineEnde: TDateTimeField;
    XDTermineBetreff: TStringField;
    XDTermineColor: TIntegerField;
    XDTermineAlarm: TBooleanField;
    XDTerminePersonalnummer: TIntegerField;
    XDTermineTerminArt: TIntegerField;
    XDTermineBeginnDatum: TDateTimeField;
    XDTermineBeginnUhrzeit: TDateTimeField;
    XDTermineEndeDatum: TDateTimeField;
    XDTermineEndeUhrzeit: TDateTimeField;
    XDTerminePNachname: TStringField;
    XDTerminePVorname: TStringField;
    XDTerminePFarbe: TIntegerField;
    TC: TTableControl;
    comboMonat: TComboBox;
    comboJahr: TComboBox;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    btnzurueck: TButton;
    Container3: THTMLContainer;
    lblhinweis: TLabel;
    XDTermineAuftrag: TStringField;
    XDTermineTerminNotiz: TStringField;
    XDTermineKundennummer: TStringField;
    XDTermineNachname: TStringField;
    XDTermineKontaktart: TStringField;
    XDTermineVorname: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure XDTermineAfterOpen(DataSet: TDataSet);
    procedure comboMonatChange(Sender: TObject);
    procedure comboJahrChange(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
    procedure WebFormHashChange(Sender: TObject; oldURL, newURL: string);
  private
    { Private-Deklarationen }
  public
    NeuerTermin:THTMLDiv;
    einzeltermin:THTMLDiv;
    buttonauftragnummer:TButton;
    procedure Termineladen;
    procedure NeuerTerminclick(Sender:TObject);
    procedure einzelterminclick(Sender:TObject);
    procedure buttonauftragnummerclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  Terminkalender: TTerminkalender;
  Startdatum:TDateTime;
  EndeDatum:TDateTime;
  mymonat:integer;

implementation
  uses unit1, unit2, unit_artikelsuche, unit_kontaktsuche, unit_einzeltermin, unit_Objektsuche, unit_Einzelauftrag;
{$R *.dfm}


procedure TTerminkalender.buttonauftragnummerclick(Sender:TObject);
var
  EinzelAuftrag:TEinzelAuftrag;
  MyMerkerAuftrag:string;
begin
  myMerkerAuftrag:=(sender as TButton).Caption;
  EinzelAuftrag := TEinzelAuftrag.CreateNew(procedure(AForm: TObject)
    begin
      (AForm as TEinzelAuftrag).MerkerAuftrag:=myMerkerAuftrag;
      tc.Visible:=false;
    end
    );

  EinzelAuftrag.ShowModal(procedure(AValue: TModalResult)
    begin
     Termineladen;
    end
    );
end;

procedure TTerminkalender.btnzurueckClick(Sender: TObject);
begin
  XDTermine.Close;
  self.Close;
end;

procedure TTerminkalender.comboJahrChange(Sender: TObject);
begin
  Termineladen;
end;

procedure TTerminkalender.comboMonatChange(Sender: TObject);
begin
  Termineladen;
end;

procedure TTerminkalender.einzelterminclick(Sender:TObject);
  var
  LFrm:TfrmEinzeltermin;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmEinzeltermin;
    begin
      LForm:=(AForm as TfrmEinzeltermin);
      lform.TerminUID:=(sender as THTMLDiv).ElementID;;
      tc.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      Termineladen;
    end;

  begin
  LFrm:=TfrmEinzeltermin.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TTerminkalender.NeuerTerminclick(Sender:TObject);
    var
  LFrm:TfrmEinzeltermin;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmEinzeltermin;
    begin
      LForm:=(AForm as TfrmEinzeltermin);
      lform.TerminUID:='';
      decodedatetime(date+time,ajahr,amonat,atag,astunde,aminute,asekunde,ams);
      decodedate((sender as THTMLDiv).Tag,ajahr,amonat,atag);
      lform.NeuStartDateTime:=encodedatetime(ajahr, amonat,atag,astunde,0,0,0);
      lform.NeuEndDateTime:=encodedatetime(ajahr, amonat,atag,astunde+1,0,0,0);
      tc.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      Termineladen;
    end;

  begin
  LFrm:=TfrmEinzeltermin.CreateNew(@AfterCreate);
  LFrm.ShowModal(@AfterShowmodal);
end;

procedure TTerminkalender.Termineladen;
begin
  if combomonat.ItemIndex=0 then
  begin
    Startdatum:=date;
    mymonat:=MonthOf(Startdatum);
    EndeDatum:=EndOfTheMonth(Startdatum);
  end
  else
  begin
    mymonat:=combomonat.ItemIndex;
    Startdatum:=encodedate(strtoint(combojahr.Text),mymonat,1);
    EndeDatum:=EndOfTheMonth(Startdatum);
  end;
  xdtermine.Close;
  if form1.RCW.NurPersTermine=true then
  begin
    xdtermine.QueryString:='$Filter=(Beginn ge '+formatdatetime('yyyy-mm-dd',Startdatum-1)+') AND (Beginn le '+formatdatetime('yyyy-mm-dd',endedatum+1)+') AND (Personalnummer eq '+BenutzerPersonalnummer+') &$orderby=Beginn';
  end
  else
  begin
    xdtermine.QueryString:='$Filter=(Beginn ge '+formatdatetime('yyyy-mm-dd',Startdatum-1)+') AND (Beginn le '+formatdatetime('yyyy-mm-dd',endedatum+1)+') &$orderby=Beginn';
  end;

  XDTermine.Load;
end;

procedure TTerminkalender.WebFormHashChange(Sender: TObject; oldURL,
  newURL: string);
begin
  if window.location.hash = '' then btnzurueckClick(sender);
end;

procedure TTerminkalender.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Terminübersicht</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  lblhinweis.ParentElement:=myelement;
  comboJahr.ParentElement:=myelement;
  comboMonat.ParentElement:=myelement;
  comboJahr.Items.Clear;
  decodedate(date,ajahr,amonat,atag);
  mymonat:=amonat;
  combojahr.Items.Add(inttostr(ajahr-5));
  combojahr.Items.Add(inttostr(ajahr-4));
  combojahr.Items.Add(inttostr(ajahr-3));
  combojahr.Items.Add(inttostr(ajahr-2));
  combojahr.Items.Add(inttostr(ajahr-1));
  combojahr.Items.Add(inttostr(ajahr));
  combojahr.Items.Add(inttostr(ajahr+1));
  combojahr.Items.Add(inttostr(ajahr+2));
  combojahr.Items.Add(inttostr(ajahr+3));
  combojahr.Items.Add(inttostr(ajahr+4));
  combojahr.Items.Add(inttostr(ajahr+5));
  combojahr.ItemIndex:=5;
  combomonat.ItemIndex:=0;
  myelement:=container3.ElementHandle;
  tc.ParentElement:=myelement;
  Termineladen;
end;

procedure TTerminkalender.XDTermineAfterOpen(DataSet: TDataSet);
var
  i:integer;
  terminstring:string;
  myelement:TJSHTMLElement;
  mybtnelement:TJSHTMLElement;
  laufendesdatum:TDateTime;
  myTag:integer;
  farbstring:string;
  mystarttag:integer;
begin
  TC.Visible:=true;
  TC.RowCount:=35;
  TC.ColCount:=1;
  i:=0;
  TC.Cells[0,i]:='<i>Neuer Termin > Tagesdatum anklicken</i><br>';
  inc(i);

  laufendesdatum:=Startdatum;
  while laufendesdatum<endedatum do
  begin

    myelement:=TC.cellelements[0,i];
    myelement.innerHTML:='';
    NeuerTermin:=THTMLDiv.Create(self);

    NeuerTermin.HeightStyle:=ssauto;
    NeuerTermin.WidthStyle:=ssauto;
    NeuerTermin.tag:=trunc(laufendesdatum);
    NeuerTermin.ElementID:=inttostr(trunc(laufendesdatum));
    if DayOfTheWeek(laufendesdatum)>5 then
    begin
      NeuerTermin.ElementClassName:='text-danger';
      NeuerTermin.HTML.Text:= '<b>'+formatdatetime('DDD DD.MM.YYYY',laufendesdatum)+'</b>';
    end
    else
    begin
      NeuerTermin.ElementClassName:='text-dark';
      NeuerTermin.HTML.Text:= '<b>'+formatdatetime('DDD DD.MM.YYYY',laufendesdatum)+'</b>';
    end;

    NeuerTermin.OnClick:=@NeuerTerminClick;
    NeuerTermin.ParentElement:=myelement;


    laufendesdatum:=laufendesdatum+1;
    inc(i);

  end;
  TC.RowCount:=i;
  mystarttag:=DayOf(startdatum)-1;
  xdtermine.First;
  while not xdtermine.eof do
  begin
    DecodeDateTime(xdterminebeginn.asdatetime,ajahr,amonat,atag,astunde,aminute,asekunde,ams);
    mytag:=atag-mystarttag;
    if (amonat=mymonat) and (mytag>0) then
    begin
      // Termin (0)
      if XDTermineTerminArt.AsInteger=0 then
      begin
        terminstring:='<div class="card-header">';
        If trunc(XDTermineBeginn.AsDateTime)=trunc(XDTermineEnde.AsDateTime) then
        begin
          terminstring:=terminstring+formatdatetime('DDD DD.MM.YYYY hh:mm',XDTermineBeginn.Asdatetime)+' - '+formatdatetime('hh:mm',XDTermineEndeUhrzeit.Asdatetime);

        end
        else
        begin
          terminstring:=terminstring+formatdatetime('DDD DD.MM.YYYY hh:mm',XDTermineBeginn.Asdatetime)+' - '+formatdatetime('DDD DD.MM.YYYY hh:mm',XDTermineEnde.Asdatetime);
        end;
        terminstring:=terminstring+'</div>';
        terminstring:=terminstring+'<div class="card-body">';
        terminstring:=terminstring+'<h6>'+XDTermineBetreff.AsString+'</h6>';
        if XDTermineTerminNotiz.AsString<>'' then
        begin
          terminstring:=terminstring+XDTermineTerminNotiz.AsString;
        end;
        if (XDTerminePersonalnummer.AsString<>'') AND (xdterminePersonalnummer.AsInteger>0) then
        begin
          farbstring:=inttohex(XDTerminePFarbe.asinteger,6);
          farbstring := Copy(farbstring, 5, 2) + Copy(farbstring, 3, 2) + Copy(farbstring, 1, 2);
          terminstring:=terminstring+'</div>';
          terminstring:=terminstring+'<div class="card-footer" style="background-color: #'+farbstring+';">';
          terminstring:=terminstring+XDTerminePersonalnummer.AsString+' | '+xdterminePVorname.asstring+' '+XDTerminePNachname.asstring;
        end;



        myelement:=TC.cellelements[0,mytag];
        einzeltermin:=THTMLDiv.Create(self);
        einzeltermin.ElementID:=xdtermineuid.asstring;
        einzeltermin.HeightStyle:=ssauto;
        einzeltermin.Width:=350;
        einzeltermin.AlignWithMargins:=true;
        einzeltermin.HTML.Text:=terminstring;
        einzeltermin.ElementClassName:='card my-2 bg-info';
        Einzeltermin.OnClick:=@EinzelterminClick;
        einzeltermin.ParentElement:=myelement;
        if XDTermineAuftrag.AsString<>'' then
        begin
          buttonauftragnummer:=TButton.Create(self);
          buttonauftragnummer.ElementClassName:='btn btn-success btn-sm m-1 text-left';
          buttonauftragnummer.HeightStyle:=ssauto;
          buttonauftragnummer.Width:=120;
          buttonauftragnummer.tag:=0;
          buttonauftragnummer.Caption:=XDTermineAuftrag.asstring;
          buttonauftragnummer.OnClick:=@buttonauftragnummerClick;
          buttonauftragnummer.ParentElement:=einzeltermin.ElementHandle;
        end;
      end;
      // Wiedervorlage (1)
      if XDTermineTerminArt.AsInteger=1 then
      begin
        terminstring:='<I>Wiedervorlage</I>'+ XDTermineBetreff.AsString;
        if XDTermineTerminNotiz.AsString<>'' then
        begin
          terminstring:=terminstring+'<br>'+XDTermineTerminNotiz.AsString;

        end;
        terminstring:=terminstring+'<br>'+XDTermineKundennummer.AsString+' '+XDTermineNachname.AsString;
        myelement:=TC.cellelements[0,mytag];
        einzeltermin:=THTMLDiv.Create(self);
        einzeltermin.ElementID:=xdtermineuid.asstring;
        einzeltermin.HeightStyle:=ssauto;
        einzeltermin.Width:=350;
        einzeltermin.AlignWithMargins:=true;
        einzeltermin.HTML.Text:=terminstring;
        einzeltermin.ElementClassName:='card my-2 bg-success';
        Einzeltermin.OnClick:=@EinzelterminClick;
        einzeltermin.ParentElement:=myelement;
      end;
      //Geburtstag(2)
      if XDTermineTerminArt.AsInteger=2 then
      begin
        terminstring:='<I>Geburtstag</I>'+ XDTermineBetreff.AsString;
        myelement:=TC.cellelements[0,mytag];
        einzeltermin:=THTMLDiv.Create(self);
        einzeltermin.ElementID:=xdtermineuid.asstring;
        einzeltermin.HeightStyle:=ssauto;
        einzeltermin.Width:=350;
        einzeltermin.AlignWithMargins:=true;
        einzeltermin.HTML.Text:=terminstring;
        einzeltermin.ElementClassName:='card my-2 bg-danger';
        Einzeltermin.OnClick:=@EinzelterminClick;
        einzeltermin.ParentElement:=myelement;
      end;
      // Aktivität (3)
      if XDTermineTerminArt.AsInteger=3 then
      begin
        terminstring:='<I>Aktivität</I>';
        If trunc(XDTermineBeginn.AsDateTime)=trunc(XDTermineEnde.AsDateTime) then
        begin
        terminstring:=terminstring+formatdatetime('DDD DD.MM.YYYY hh:mm',XDTermineBeginn.Asdatetime)+' - '+formatdatetime('hh:mm',XDTermineEndeUhrzeit.Asdatetime);
        terminstring:=terminstring+'<br>'+ XDTermineBetreff.AsString+'<br>';
        end
        else
        begin
        terminstring:=formatdatetime('DDD DD.MM.YYYY hh:mm',XDTermineBeginn.Asdatetime)+' - '+formatdatetime('DDD DD.MM.YYYY hh:mm',XDTermineEnde.Asdatetime);
        terminstring:=terminstring+'<br>'+ XDTermineBetreff.AsString+'<br>';
        end;
        if XDTermineTerminNotiz.AsString<>'' then
        begin
          terminstring:=terminstring+XDTermineTerminNotiz.AsString+'<br>';
        end;
        terminstring:=terminstring+'<br>'+XDTermineKundennummer.AsString+' '+XDTermineNachname.AsString;
        terminstring:=terminstring+'<br>'+XDTermineKontaktart.AsString;
        myelement:=TC.cellelements[0,mytag];
        einzeltermin:=THTMLDiv.Create(self);
        einzeltermin.ElementID:=xdtermineuid.asstring;
        einzeltermin.HeightStyle:=ssauto;
        einzeltermin.Width:=350;
        einzeltermin.AlignWithMargins:=true;
        einzeltermin.HTML.Text:=terminstring;
        einzeltermin.ElementClassName:='card my-2 bg-primary';
        Einzeltermin.OnClick:=@EinzelterminClick;
        einzeltermin.ParentElement:=myelement;
      end;
      // Feiertag (5)
      if XDTermineTerminArt.AsInteger=5 then
      begin
        myelement:=TC.cellelements[0,mytag];
        myelement.innerHTML:='';
        NeuerTermin:=THTMLDiv.Create(self);
        NeuerTermin.HeightStyle:=ssauto;
        NeuerTermin.WidthStyle:=ssauto;
        NeuerTermin.tag:=trunc(XDTermineBeginn.Asdatetime);
        NeuerTermin.ElementID:=inttostr(trunc(XDTermineBeginn.Asdatetime));
        NeuerTermin.ElementClassName:='text-danger';
        NeuerTermin.HTML.Text:='<b>'+formatdatetime('DDD DD.MM.YYYY',XDTermineBeginn.Asdatetime)+' '+XDTermineBetreff.AsString+'</b>';
        NeuerTermin.OnClick:=@NeuerTerminClick;
        NeuerTermin.ParentElement:=myelement;
      end;

    end;
      xdtermine.Next;
  end;
end;

procedure TTerminkalender.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblhinweis := TLabel.Create(Self);
  TC := TTableControl.Create(Self);
  comboMonat := TComboBox.Create(Self);
  comboJahr := TComboBox.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  sourceTermine := TDataSource.Create(Self);
  XDTermine := TXDataWebDataSet.Create(Self);
  XDTermineUID := TStringField.Create(Self);
  XDTermineBeginn := TDateTimeField.Create(Self);
  XDTermineEnde := TDateTimeField.Create(Self);
  XDTermineBetreff := TStringField.Create(Self);
  XDTermineColor := TIntegerField.Create(Self);
  XDTermineAlarm := TBooleanField.Create(Self);
  XDTerminePersonalnummer := TIntegerField.Create(Self);
  XDTermineTerminArt := TIntegerField.Create(Self);
  XDTermineBeginnDatum := TDateTimeField.Create(Self);
  XDTermineBeginnUhrzeit := TDateTimeField.Create(Self);
  XDTermineEndeDatum := TDateTimeField.Create(Self);
  XDTermineEndeUhrzeit := TDateTimeField.Create(Self);
  XDTerminePNachname := TStringField.Create(Self);
  XDTerminePVorname := TStringField.Create(Self);
  XDTerminePFarbe := TIntegerField.Create(Self);
  XDTermineAuftrag := TStringField.Create(Self);
  XDTermineTerminNotiz := TStringField.Create(Self);
  XDTermineKundennummer := TStringField.Create(Self);
  XDTermineNachname := TStringField.Create(Self);
  XDTermineKontaktart := TStringField.Create(Self);
  XDTermineVorname := TStringField.Create(Self);

  lblhinweis.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  comboMonat.BeforeLoadDFMValues;
  comboJahr.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  sourceTermine.BeforeLoadDFMValues;
  XDTermine.BeforeLoadDFMValues;
  XDTermineUID.BeforeLoadDFMValues;
  XDTermineBeginn.BeforeLoadDFMValues;
  XDTermineEnde.BeforeLoadDFMValues;
  XDTermineBetreff.BeforeLoadDFMValues;
  XDTermineColor.BeforeLoadDFMValues;
  XDTermineAlarm.BeforeLoadDFMValues;
  XDTerminePersonalnummer.BeforeLoadDFMValues;
  XDTermineTerminArt.BeforeLoadDFMValues;
  XDTermineBeginnDatum.BeforeLoadDFMValues;
  XDTermineBeginnUhrzeit.BeforeLoadDFMValues;
  XDTermineEndeDatum.BeforeLoadDFMValues;
  XDTermineEndeUhrzeit.BeforeLoadDFMValues;
  XDTerminePNachname.BeforeLoadDFMValues;
  XDTerminePVorname.BeforeLoadDFMValues;
  XDTerminePFarbe.BeforeLoadDFMValues;
  XDTermineAuftrag.BeforeLoadDFMValues;
  XDTermineTerminNotiz.BeforeLoadDFMValues;
  XDTermineKundennummer.BeforeLoadDFMValues;
  XDTermineNachname.BeforeLoadDFMValues;
  XDTermineKontaktart.BeforeLoadDFMValues;
  XDTermineVorname.BeforeLoadDFMValues;
  try
    Name := 'Terminkalender';
    Width := 239;
    Height := 484;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnHashChange', 'WebFormHashChange');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblhinweis.SetParentComponent(Self);
    lblhinweis.Name := 'lblhinweis';
    lblhinweis.Left := 128;
    lblhinweis.Top := 160;
    lblhinweis.Width := 255;
    lblhinweis.Height := 15;
    lblhinweis.Caption := 'lblhinweis';
    lblhinweis.ElementClassName := 'h6 m-2';
    lblhinweis.ElementFont := efCSS;
    lblhinweis.ElementPosition := epIgnore;
    lblhinweis.HeightStyle := ssAuto;
    lblhinweis.HeightPercent := 100.000000000000000000;
    lblhinweis.HTML := '<i> Jahr und Monat f'#252'r die Anzeige w'#228'hlen </i>';
    lblhinweis.WidthStyle := ssAuto;
    lblhinweis.WidthPercent := 100.000000000000000000;
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 8;
    TC.Top := 256;
    TC.Width := 217;
    TC.Height := 134;
    TC.ElementClassName := 'table table-sm table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderStyle := bsNone;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 5;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-sm table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    comboMonat.SetParentComponent(Self);
    comboMonat.Name := 'comboMonat';
    comboMonat.Left := 8;
    comboMonat.Top := 184;
    comboMonat.Width := 145;
    comboMonat.Height := 23;
    comboMonat.ElementClassName := 'form-select';
    comboMonat.ElementFont := efCSS;
    comboMonat.ElementPosition := epIgnore;
    comboMonat.HeightStyle := ssAuto;
    comboMonat.HeightPercent := 100.000000000000000000;
    comboMonat.Text := 'Ganzes Jahr';
    comboMonat.WidthPercent := 100.000000000000000000;
    SetEvent(comboMonat, Self, 'OnChange', 'comboMonatChange');
    comboMonat.ItemIndex := -1;
    comboMonat.Items.BeginUpdate;
    try
      comboMonat.Items.Clear;
      comboMonat.Items.Add('ab heute');
      comboMonat.Items.Add('Januar');
      comboMonat.Items.Add('Februar');
      comboMonat.Items.Add('M'#228'rz');
      comboMonat.Items.Add('April');
      comboMonat.Items.Add('Mai');
      comboMonat.Items.Add('Juni');
      comboMonat.Items.Add('Juli');
      comboMonat.Items.Add('August');
      comboMonat.Items.Add('September');
      comboMonat.Items.Add('Oktober');
      comboMonat.Items.Add('November');
      comboMonat.Items.Add('Dezember');
    finally
      comboMonat.Items.EndUpdate;
    end;
    comboJahr.SetParentComponent(Self);
    comboJahr.Name := 'comboJahr';
    comboJahr.Left := 8;
    comboJahr.Top := 211;
    comboJahr.Width := 145;
    comboJahr.Height := 23;
    comboJahr.ElementClassName := 'form-select';
    comboJahr.ElementFont := efCSS;
    comboJahr.ElementPosition := epIgnore;
    comboJahr.HeightStyle := ssAuto;
    comboJahr.HeightPercent := 100.000000000000000000;
    comboJahr.Text := '2020';
    comboJahr.WidthPercent := 100.000000000000000000;
    SetEvent(comboJahr, Self, 'OnChange', 'comboJahrChange');
    comboJahr.ItemIndex := 5;
    comboJahr.Items.BeginUpdate;
    try
      comboJahr.Items.Clear;
      comboJahr.Items.Add('2015');
      comboJahr.Items.Add('2016');
      comboJahr.Items.Add('2017');
      comboJahr.Items.Add('2018');
      comboJahr.Items.Add('2019');
      comboJahr.Items.Add('2020');
      comboJahr.Items.Add('2021');
      comboJahr.Items.Add('2022');
    finally
      comboJahr.Items.EndUpdate;
    end;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 8;
    btnzurueck.Top := 153;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    sourceTermine.SetParentComponent(Self);
    sourceTermine.Name := 'sourceTermine';
    sourceTermine.DataSet := XDTermine;
    sourceTermine.Left := 52;
    sourceTermine.Top := 16;
    XDTermine.SetParentComponent(Self);
    XDTermine.Name := 'XDTermine';
    XDTermine.AfterOpen := XDTermineAfterOpen;
    XDTermine.EntitySetName := 'TermineNeu';
    XDTermine.Connection := DM2.XDataWebConnection1;
    XDTermine.QueryString := '$Filter=(Year(Beginn) eq 2019) &$orderby=Beginn';
    XDTermine.Left := 124;
    XDTermine.Top := 14;
    XDTermineUID.SetParentComponent(XDTermine);
    XDTermineUID.Name := 'XDTermineUID';
    XDTermineUID.FieldName := 'UID';
    XDTermineUID.Required := True;
    XDTermineUID.Size := 38;
    XDTermineBeginn.SetParentComponent(XDTermine);
    XDTermineBeginn.Name := 'XDTermineBeginn';
    XDTermineBeginn.FieldName := 'Beginn';
    XDTermineEnde.SetParentComponent(XDTermine);
    XDTermineEnde.Name := 'XDTermineEnde';
    XDTermineEnde.FieldName := 'Ende';
    XDTermineBetreff.SetParentComponent(XDTermine);
    XDTermineBetreff.Name := 'XDTermineBetreff';
    XDTermineBetreff.FieldName := 'Betreff';
    XDTermineBetreff.Size := 255;
    XDTermineColor.SetParentComponent(XDTermine);
    XDTermineColor.Name := 'XDTermineColor';
    XDTermineColor.FieldName := 'Color';
    XDTermineAlarm.SetParentComponent(XDTermine);
    XDTermineAlarm.Name := 'XDTermineAlarm';
    XDTermineAlarm.FieldName := 'Alarm';
    XDTerminePersonalnummer.SetParentComponent(XDTermine);
    XDTerminePersonalnummer.Name := 'XDTerminePersonalnummer';
    XDTerminePersonalnummer.FieldName := 'Personalnummer';
    XDTermineTerminArt.SetParentComponent(XDTermine);
    XDTermineTerminArt.Name := 'XDTermineTerminArt';
    XDTermineTerminArt.FieldName := 'TerminArt';
    XDTermineBeginnDatum.SetParentComponent(XDTermine);
    XDTermineBeginnDatum.Name := 'XDTermineBeginnDatum';
    XDTermineBeginnDatum.FieldName := 'BeginnDatum';
    XDTermineBeginnUhrzeit.SetParentComponent(XDTermine);
    XDTermineBeginnUhrzeit.Name := 'XDTermineBeginnUhrzeit';
    XDTermineBeginnUhrzeit.FieldName := 'BeginnUhrzeit';
    XDTermineEndeDatum.SetParentComponent(XDTermine);
    XDTermineEndeDatum.Name := 'XDTermineEndeDatum';
    XDTermineEndeDatum.FieldName := 'EndeDatum';
    XDTermineEndeUhrzeit.SetParentComponent(XDTermine);
    XDTermineEndeUhrzeit.Name := 'XDTermineEndeUhrzeit';
    XDTermineEndeUhrzeit.FieldName := 'EndeUhrzeit';
    XDTerminePNachname.SetParentComponent(XDTermine);
    XDTerminePNachname.Name := 'XDTerminePNachname';
    XDTerminePNachname.FieldName := 'PNachname';
    XDTerminePNachname.Size := 40;
    XDTerminePVorname.SetParentComponent(XDTermine);
    XDTerminePVorname.Name := 'XDTerminePVorname';
    XDTerminePVorname.FieldName := 'PVorname';
    XDTerminePVorname.Size := 40;
    XDTerminePFarbe.SetParentComponent(XDTermine);
    XDTerminePFarbe.Name := 'XDTerminePFarbe';
    XDTerminePFarbe.FieldName := 'PFarbe';
    XDTermineAuftrag.SetParentComponent(XDTermine);
    XDTermineAuftrag.Name := 'XDTermineAuftrag';
    XDTermineAuftrag.FieldName := 'Auftrag';
    XDTermineAuftrag.Size := 10;
    XDTermineTerminNotiz.SetParentComponent(XDTermine);
    XDTermineTerminNotiz.Name := 'XDTermineTerminNotiz';
    XDTermineTerminNotiz.FieldName := 'TerminNotiz';
    XDTermineTerminNotiz.Size := 255;
    XDTermineKundennummer.SetParentComponent(XDTermine);
    XDTermineKundennummer.Name := 'XDTermineKundennummer';
    XDTermineKundennummer.FieldName := 'Kundennummer';
    XDTermineKundennummer.Size := 13;
    XDTermineNachname.SetParentComponent(XDTermine);
    XDTermineNachname.Name := 'XDTermineNachname';
    XDTermineNachname.FieldName := 'Nachname';
    XDTermineNachname.Size := 40;
    XDTermineKontaktart.SetParentComponent(XDTermine);
    XDTermineKontaktart.Name := 'XDTermineKontaktart';
    XDTermineKontaktart.FieldName := 'Kontaktart';
    XDTermineKontaktart.Size := 25;
    XDTermineVorname.SetParentComponent(XDTermine);
    XDTermineVorname.Name := 'XDTermineVorname';
    XDTermineVorname.FieldName := 'Vorname';
    XDTermineVorname.Size := 40;
  finally
    lblhinweis.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    comboMonat.AfterLoadDFMValues;
    comboJahr.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    sourceTermine.AfterLoadDFMValues;
    XDTermine.AfterLoadDFMValues;
    XDTermineUID.AfterLoadDFMValues;
    XDTermineBeginn.AfterLoadDFMValues;
    XDTermineEnde.AfterLoadDFMValues;
    XDTermineBetreff.AfterLoadDFMValues;
    XDTermineColor.AfterLoadDFMValues;
    XDTermineAlarm.AfterLoadDFMValues;
    XDTerminePersonalnummer.AfterLoadDFMValues;
    XDTermineTerminArt.AfterLoadDFMValues;
    XDTermineBeginnDatum.AfterLoadDFMValues;
    XDTermineBeginnUhrzeit.AfterLoadDFMValues;
    XDTermineEndeDatum.AfterLoadDFMValues;
    XDTermineEndeUhrzeit.AfterLoadDFMValues;
    XDTerminePNachname.AfterLoadDFMValues;
    XDTerminePVorname.AfterLoadDFMValues;
    XDTerminePFarbe.AfterLoadDFMValues;
    XDTermineAuftrag.AfterLoadDFMValues;
    XDTermineTerminNotiz.AfterLoadDFMValues;
    XDTermineKundennummer.AfterLoadDFMValues;
    XDTermineNachname.AfterLoadDFMValues;
    XDTermineKontaktart.AfterLoadDFMValues;
    XDTermineVorname.AfterLoadDFMValues;
  end;
end;

end.
